import React, { useReducer } from "react";
import { reducer, initialState } from "./reducer";

const contextName = "Notification";

const StateContext = React.createContext();
const DispatchContext = React.createContext();

export function useNotificationState() {
  const context = React.useContext(StateContext);
  if (context === undefined) {
    throw new Error(
      `useAuthState must be used within a ${contextName}Provider`
    );
  }

  return context;
}

export function useNotificationDispatch() {
  const context = React.useContext(DispatchContext);
  if (context === undefined) {
    throw new Error(
      `useNotificationState must be used within a ${contextName}Provider`
    );
  }

  return context;
}

export const NotificationProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};
